<template>
  <div  class="app-wrapper">
    <div  class="main-container">
      <navbar />
      <slider v-if="$route.name!=='dictionary'"></slider>
      <app-main />
      <Footer1></Footer1>
    </div>
  </div>
</template>

<script>
import { AppMain, Navbar, slider } from './components/index'
import '../assets/css/global.scss'
export default {
  name: 'Layout',
  components: {
    AppMain,
    slider,
    Navbar
  }
}
</script>

<style lang="scss" scoped>
  .app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue